export const VERIFY_CODE_SUCCESS = 'VERIFY_CODE_SUCCESS';

export const OPEN_PHONE_VERIFICATION_MODAL = 'OPEN_PHONE_VERIFICATION_MODAL';
export const CLOSE_PHONE_VERIFICATION_MODAL = 'CLOSE_PHONE_VERIFICATION_MODAL';

export const verifyCodeSuccess = () =>
  ({
    type: VERIFY_CODE_SUCCESS,
    payload: {},
  }) as const;

export type VerifyCodeSuccessAction = ReturnType<typeof verifyCodeSuccess>;

export type PhoneVerificationActions = VerifyCodeSuccessAction;
